export default __webpack_public_path__ + "static/media/building.f6765384.svg";